angular.module('capability-ng-scheduler').factory('RequiredSectionBuilder', function RequiredSectionBuilder(Interface) {
  const DTD = {
    name: 'string',
    section_type: 'ngObject',
    sections: 'ngArray',
    course: 'ngObject'
  };

  function RequiredSectionDTO(data) {
    Interface.implement(DTD, data, this);
  }

  return RequiredSectionDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/required_section_builder.es.js